export const HomeIcon = (
  <svg
    width="30"
    height="30"
    style={{ top: 20, left: 20, position: "fixed" }}
    viewBox="0 0 14 14"
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 8L7 1.5L13.5 8"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 6V12.5H11.5V6"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
